<template lang="pug">
div.process-content
  div.header-title
    a.tag-page(@click="$router.push('/Student/home')") 首页 /
    a.tag-page 流程演练
  div.meun-item(v-if="list.length>0")
    //- span.tag-number 序号
    span.tag-number 实验名称
    span 完成阶段
    span.tag-1 开始时间
    span 结束时间
    span.tag-2 系统评分
    span.tag-3 教师评分
    span 操作
  div.content
    //- div.content-title {{$route.query.id===1?'流程演练':'政策分析'}}
    div.null(v-if="list.length<1") 暂无数据
    div.meun-nav(v-if="list.length>0")
      div.meun-list(v-for='(v,idx) in list')
        //- div.tag-3.tagblog {{idx+1}}
        div.block.tag_blog
          div.tag-nav {{v.experimentName}}
        div.block-0.tag_blog
          Tooltip(:content="v.distribution" placement="top-start")
            span {{v.distribution}}
        div.block-1.tag_blog
          div.tag-4 {{v.startTime}}
        div.block-2.tag_blog
          div {{v.endTime}}
        div.block-3.tag_blog
          div.tag-5 {{v.systemSocre}}
        div.block-4.tag_blog
          div.tag-5 {{v.tercherSocre}}
        span
          a(@click="preview(v.experimentId,v.finish,v.viewReport,v.viewAnswer)") 预览
          span.separate  |
          a(@click="download(v.experimentId,v.isTeacherScore,v.viewReport)") 下载报告
  Page.page(@on-change="handleCurrentChange" :total="pageData.totalRecords" v-if="list.length>0"
    :page-size="10" :current="pageData.pageNo" show-elevator show-total)
    span 当前有{{list.length}}条数据，共{{pageData.totalRecords}}条数据
</template>

<script>
export default {
  data() {
    return {
      pageData: {}, // 表格分页数据
      page: 1,
      list: []
    };
  },
  methods: {
    handleCurrentChange(page) {
      // 分页函数
      this.page = page;
      this.query();
    },
    query() {
      // 流程演练 查看详情
      const data = {
        userId: this.$role.code,
        pageNo: this.page,
        pageSize: 10
      };
      this.$http.Seedetails(data).then(res => {
        console.log(res);
        if (res.data.success) {
          this.list = res.data.data.list.map(item => {
            if (item.experimentMemberAuditStatus === "未提交") {
              item.systemSocre = "待评分";
              item.tercherSocre = "待评分";
            } else if (item.experimentMemberAuditStatus === "待审批") {
              if (item.systemSocre === null) {
                item.systemSocre = "待评分";
              }
              item.tercherSocre = "待评分";
            }
            // if (!item.tercherSocre) {
            // }
            return item;
          });
          this.pageData = res.data.data;
          console.log(this.list);
        }
      });
    },
    preview(h, i, z, y) {
      if (i) {
        this.$router.push({
          path: "/stuReport",
          query: {
            usercode: this.$role.code,
            experimentid: h,
            isviewAnswer: y
          }
        });
      } else {
        this.$Message.warning("请先完成该实训");
      }
    },
    downloadFile(url, fileName) {
      // 下载单个文件
      const a = document.createElement("a");
      a.href = url;
      if (fileName) {
        a.download = fileName;
      } else {
        a.download = "";
      }
      a.click();
    },
    download(f, i, v) {
      // 下载pdf报告
      if (v) {
        const data = {
          experimentId: f,
          userId: this.$role.code
        };
        console.log(f);
        if (i === true) {
          this.$http.exportExperimentReport(data).then(res => {
            console.log(res);
            if (res.data.success) {
              this.downloadFile(res.data.data);
              // console.log(res.data.data)
              this.$Message.success("正在下载");
            } else {
              this.$Message.warning(res.data.message);
            }
          });
        } else {
          this.$Message.error("教师评分后可下载!");
        }
      } else {
        this.$Message.error("该实训报告不可下载!");
      }
    }
  },
  created() {
    this.query();
  }
};
</script>

<style lang="stylus" scoped>
.process-content
  width 100%
  max-width 1128px
  margin 0 auto
  overflow hidden
  .header-title
    text-align left
    margin 25px 0 16px 0
    .tag-page
      font-size 12px
      font-family MicrosoftYaHeiUI
      color rgba(58, 118, 210, 1)
  .content
    height 466px
    // box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.04);
    border-radius 4px
    overflow hidden
    .null
      font-size 28px
      line-height 300px
      text-align center
    .content-title
      height 60px
      line-height 60px
      text-align left
      font-size 14px
      font-family MicrosoftYaHeiUI-Bold
      font-weight bold
      color #2A2E36
      margin-left 24px
    .meun-nav
      height 44px
  .meun-item
    text-align left
    // background #F2F4F5
    height 48px
    line-height 48px
    font-size 14px
    font-family MicrosoftYaHeiUI
    color rgba(42, 46, 54, 1)
    .tag-number
      margin 0 185px 0 40px
    .tag-1
      margin 0 121px 0 146px
    .tag-2
      margin 0px 30px 0 90px
    .tag-3
      margin 0px 70px 0 8px
  .meun-list
    white-space nowrap
    text-align left
    background #FFFFFF
    line-height 44px
    font-size 14px
    font-family MicrosoftYaHeiUI
    color rgba(42, 46, 54, 0.75)
    border-radius 4px
    border-bottom 1px solid #ccc
    .tag-5
      white-space nowrap
    .tag-3
      margin 0 28px 0 33px
      display inline-block
      width 10px
    .tag_blog
      float left
    .block
      display inline-block
      max-width 206px
      width 199px
      margin 0 28px 0 33px
      .tag-nav
        // display: -webkit-box;
        // -webkit-box-orient: vertical;
        // -webkit-line-clamp: 1;
        width 120px
        white-space nowrap
        overflow hidden
        text-overflow ellipsis
    .block-0
      width 120px
      overflow hidden
      text-overflow ellipsis
    .block-1
      display inline-block
      margin 0 0px 0 75px
      width 170px
    .block-2
      display inline-block
      width 170px
    .block-3
      display inline-block
      margin 0px 30px 0 20px
      width 45px
      text-align center
    .block-4
      display inline-block
      margin 0px 50px 0 20px
      width 45px
      text-align center
    .separate
      font-size 10px
      color rgba(216, 216, 216, 1)
      padding 0 10px
  .page
    margin-top 32px
    float right
    .ivu-page-total
      span
        color #999999
        font-size 14px
  /deep/ .ivu-tooltip-inner
    max-width 500px

</style>
